<section style="width: 100vw; margin: 1rem;">
  <main class="main__content col-xl-12 px-2">
    <section>
      <form [formGroup]="formData" (ngSubmit)="pesquisar()">
        <section class="content-form">
          <div class="col-12 col-sm-12 col-md-12 col-xl-12 px-1">
            <label class="label-form">Nome, CNPJ ou Registro Profissional</label>
            <input class="form-control input-form" formControlName="name"
              placeholder="Informe o Nome, CNPJ ou Registro Profissional">
            <small class="form-text text-muted danger ng-star-inserted"
              *ngIf="formData.get('name')?.touched && formData.get('name')?.invalid" [@fadeInOut]>
              O campo Nome é obrigatório!
            </small>
          </div>
          <div class="row ">
            <div class="col-sm-4 px-1">
              <label class="label-form">Cidade</label>
              <ng-select bindLabel="name" bindValue="id" formControlName="cityId" placeholder="Selecione uma Cidade"
                (change)="cityChanged()" [items]="listCities">
              </ng-select>
              <small class="form-text text-muted danger "
                *ngIf="formData.get('cityId')?.touched && formData.get('cityId')?.invalid" [@fadeInOut]>
                Por favor, selecione a Cidade
              </small>
            </div>
            <div class="col-sm-4 px-1">
              <label class="label-form">Especialidade</label>
              <ng-select bindLabel="value" bindValue="key" formControlName="medicalExpertiseId"
                placeholder="Selecione uma Especialidade" [items]="listSpecialties">
              </ng-select>
              <small class="form-text text-muted danger "
                *ngIf="formData.get('medicalExpertiseId')?.touched && formData.get('medicalExpertiseId')?.invalid"
                [@fadeInOut]>
                Por favor, selecione o Titular
              </small>
            </div>
            <div class="col-sm-4 px-1">
              <label class="label-form">Tipo de Estabelecimento</label>
              <ng-select bindLabel="value" bindValue="key" formControlName="companyTypeId"
                placeholder="Selecione um Tipo de Estabelecimento" [items]="listTypeEstablishment">
              </ng-select>
              <small class="form-text text-muted danger"
                *ngIf="formData.get('companyTypeId')?.touched && formData.get('companyTypeId')?.invalid" [@fadeInOut]>
                Por favor, selecione o Tipo de Estabelecimento
              </small>
            </div>
          </div>
          <div class="row ">
            <div class="col-sm-3 px-1">
              <label class="label-form">Bairro</label>
              <ng-select bindLabel="name" bindValue="name" formControlName="neighborhood" id="neighborhood"
                placeholder="Selecione um Titular" [items]="listNeighborhood">
              </ng-select>
              <small class="form-text text-muted danger"
                *ngIf="formData.get('neighborhood')?.touched && formData.get('neighborhood')?.invalid" [@fadeInOut]>
                Por favor, selecione o Bairro
              </small>
            </div>
            <div class="col-sm-6 px-1">
              <label class="label-form">Endereço, Telefone ou Site</label>
              <input class="form-control input-form" formControlName="companyName"
                placeholder="Informe um Endereço, Telefone ou Site">
              <small class="form-text text-muted danger ng-star-inserted"
                *ngIf="formData.get('companyName')?.touched && formData.get('companyName')?.invalid" [@fadeInOut]>
                O campo Endereço, Telefone ou Site é obrigatório!
              </small>
            </div>
            <div class="col-sm-3 px-1">
              <label class="label-form">Plano - Registro ANS</label>
              <ng-select bindLabel="value" bindValue="key" placeholder="Selecione um Titular" [items]="listPlans">
              </ng-select>
            </div>
          </div>
        </section>
        <div class="row content-button-pesquisar">
          <button class="btn button-primary mr-xl-1 mr-lg-1" type="submit">
            <div class="d-flex" *ngIf="loadingCosts; else showSpan">
              <span class="spinner">
              </span>
              <span> Pesquisando</span>
            </div>
            <ng-template #showSpan>
              <span>Pesquisar</span>
            </ng-template>
          </button>
          <button class="btn button-primary mr-xl-1 mr-lg-1" [disabled]="
                      listaRedeCredenciada?.credenciados?.totalFiltered < 0 ||
                      listaRedeCredenciada?.referenciados?.totalFiltered < 0 ||
                      listaRedeCredenciada?.novosCredenciados?.totalFiltered < 0 ||
                      listaRedeCredenciada?.descredenciados?.ultimoMes?.totalFiltered < 0 ||
                      listaRedeCredenciada?.descredenciados?.ultimoMes?.totalFiltered < 0" (click)="printPdf()">
            <div class="d-flex" *ngIf="loadingPrint; else showSpanImprimir">
              <span class="spinner">
              </span>
              <span> Download</span>
            </div>
            <ng-template #showSpanImprimir>
              <span>Versão para Impressão</span>
            </ng-template>
          </button>
        </div>
      </form>
      <ng-template #showLoadingCostsUpToday>
        <div role="status">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img class="img-loading" src="../../../../../assets/img/loading.gif" [@fadeInOut] />
            <p class="spinning-letra-carregando">Carregando...</p>
          </div>
        </div>
      </ng-template>
      <section *ngIf="pesquisa == false" class="content-aviso-status">
        <span>Preencha o formulário acima para encontrar os Credenciados!</span>
      </section>
      <section id="content-rede-credenciada" *ngIf="listaRedeCredenciada && pesquisa">
        <mat-tab-group dynamicHeight class="mt-3 content-mat-tabs">
          <mat-tab label="Credenciados ({{listaRedeCredenciada?.credenciados?.totalFiltered}})">
            <lista-redecredenciada [itens]="listaRedeCredenciada?.credenciados"
              (changePagination)="onChangePagination($event)">
            </lista-redecredenciada>
          </mat-tab>
          <mat-tab label="Referenciados ({{listaRedeCredenciada?.referenciados?.totalFiltered}})">
            <lista-redecredenciada [itens]="listaRedeCredenciada?.referenciados"
              (changePagination)="onChangePagination($event)">
            </lista-redecredenciada>
          </mat-tab>
          <mat-tab label="Novos Credenciados ({{listaRedeCredenciada?.novosCredenciados?.totalFiltered}})">
            <lista-redecredenciada [itens]="listaRedeCredenciada?.novosCredenciados"
              (changePagination)="onChangePagination($event)">
            </lista-redecredenciada>
          </mat-tab>
          <mat-tab label="Descredenciados ({{quantidadeDescredenciados}})">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
              <mat-tab label="Próximos 30 dias ({{listaRedeCredenciada?.descredenciados?.ultimoMes?.totalFiltered}})">
                <lista-redecredenciada [itens]="listaRedeCredenciada?.descredenciados?.ultimoMes"
                  (changePagination)="onChangePagination($event)">
                </lista-redecredenciada>
              </mat-tab>
              <mat-tab label="Últimos 6 meses ({{listaRedeCredenciada?.descredenciados?.ultimoMes?.totalFiltered}})">
                <lista-redecredenciada [itens]="listaRedeCredenciada?.descredenciados?.ultimoSemestre"
                  (changePagination)="onChangePagination($event)">
                </lista-redecredenciada>
              </mat-tab>
            </mat-tab-group>
          </mat-tab>
        </mat-tab-group>
      </section>
    </section>
  </main>
  <footer>
    <legenda></legenda>
  </footer>
</section>